import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Login from "./pages/Login";
import AdminLayout from "./pages/admin/AdminLayout";
import Companies from "./pages/admin/Companies";
import UserManagement from "./pages/admin/UserManagement";
import UseCaseMaster from "./pages/admin/UseCaseMaster";
import UserRoleMapping from "./pages/admin/UserRoleMapping";
import ScreenManagement from "./pages/admin/ScreenManagement";
import RoleManagement from "./pages/admin/RoleManagement";
import Authorization from "./pages/admin/UserAuthorization";
import WorkSpaces from "./pages/admin/WorkSpaces";
import WorkspaceMapping from "./pages/admin/WorkspaceMapping";
import DataSources from "./pages/admin/DataSources";
import SystemSettings from "./pages/admin/SystemSettings";
import DashboardView from "./components/adminDashboard/ui/dashboard/DashboardView";
import UserModelGroupMapping from "./pages/admin/UserModelGroupMapping";
import UserLayout from "./pages/user/UserLayout";
import Chat from "./pages/user/Chat";
import History from "./pages/user/History";
import UserSettings from "./pages/user/Settings";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ChangePassword from "./pages/ChangePassword";
import { WorkspaceSelector } from "./pages/user/WorkspaceSelector";
import SharedChat from "./pages/SharedChat";

export default function App() {
  const [darkMode, setDarkMode] = useState(() => {
    const savedTheme = localStorage.getItem("theme");
    console.log("savedTheme", savedTheme);
    if (savedTheme === "dark") return true;
    if (savedTheme === "light") return false;
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  });

  useEffect(() => {
    if (darkMode) document.documentElement.classList.add("dark");
    else document.documentElement.classList.remove("dark");
    localStorage.setItem("theme", darkMode ? "dark" : "light");
  }, [darkMode]);

   const checkAuth = () => ({
    user:
      !!localStorage.getItem("accessToken") &&
      !!localStorage.getItem("userId") &&
      localStorage.getItem("groupId") === "1" &&
      new Date(localStorage.getItem("expiresAtUtc")) > new Date(),
    admin:
      !!localStorage.getItem("accessToken") &&
      !!localStorage.getItem("userId") &&
      localStorage.getItem("groupId") !== "1" &&
      new Date(localStorage.getItem("expiresAtUtc")) > new Date(),
  });

  const [auth, setAuth] = useState(checkAuth);

  useEffect(() => {
    const handleStorage = () => setAuth(checkAuth());
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  return (
    <div
      className={`h-screen w-full overflow-hidden transition-colors duration-300 ${
        darkMode
          ? "dark bg-slate-900 text-slate-100"
          : "bg-[#e8edf3] text-slate-900"
      }`}
    >
      <main className="h-full w-full">
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/admin/change-password" element={<ChangePassword />} />
          <Route path="/shared-chat/:shareId" element={<SharedChat />} />


          {/* USER ROUTES */}
          <Route
            path="/user"
            element={
              auth.user ? (
                <UserLayout
                  darkMode={darkMode}
                  setDarkMode={setDarkMode}
                />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          >
            <Route index element={<WorkspaceSelector />} />
            <Route path="chat" element={<Chat />} />
            <Route path="history" element={<History />} />
            <Route path="settings" element={<UserSettings />} />
          </Route>

          {/* ADMIN ROUTES */}
          <Route
            path="/admin"
            element={
              auth.admin ? (
                <AdminLayout
                  darkMode={darkMode}
                  setDarkMode={setDarkMode}
                />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          >
            <Route index element={<DashboardView />} />
            <Route path="companies" element={<Companies />} />
            <Route path="screens" element={<ScreenManagement />} />
            <Route path="usermodelgroupmapping" element={<UserModelGroupMapping />} />
            <Route path="usecasemaster" element={<UseCaseMaster />} />
            <Route path="roles" element={<RoleManagement />} />
            <Route path="authorization" element={<Authorization />} />
            <Route path="userrolemapping" element={<UserRoleMapping />} />
            <Route path="users" element={<UserManagement />} />
            <Route path="workspaces" element={<WorkSpaces />} />
            <Route path="workspace-mapping" element={<WorkspaceMapping />} />
            <Route path="data" element={<DataSources />} />
            <Route path="settings" element={<SystemSettings />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>

      <style
        dangerouslySetInnerHTML={{
          __html: `
          .hide-scrollbar::-webkit-scrollbar { display: none; }
          .hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
        `,
        }}
      />
    </div>
  );
}
